export default "__VITE_ASSET__DUlZ6L3o__"